import gql from "graphql-tag";

export const DELETE_TICKET = gql`
  mutation delete_event_image_gallery_by_pk($id: [uuid!]!) {
    delete_event_paid_ticket_details(where: { id: { _in: $id } }) {
      affected_rows
    }
  }
`;
